import { ReferralMedium } from './types';

const createReferralLinkForNewFormat = (supplierName, utm_source) => {
  const source = utm_source ?? ReferralMedium.REFERRAL_LINK;
  const referralUrl = new URL(
    `https://inventa.shop/marca/${encodeURIComponent(supplierName)}/1`,
  );
  referralUrl.searchParams.set('utm_source', source);
  referralUrl.searchParams.set('utm_medium', 'share');
  referralUrl.searchParams.set('utm_campaign', supplierName);
  referralUrl.searchParams.set('ref_brand', supplierName);

  return referralUrl.toString();
};

const createReferralLinkForOldFormat = (supplierName, utm_medium) => {
  const medium = utm_medium ?? ReferralMedium.REF_LINK;
  const referralUrl = new URL('https://inventa.shop/collections/vendors');
  referralUrl.searchParams.set('utm_medium', medium);
  referralUrl.searchParams.set('utm_source', supplierName);
  referralUrl.searchParams.set('q', supplierName);

  return referralUrl.toString();
};

export const createReferralLink = (supplierName, utm_source) => {
  if (process.env.REACT_APP_ENABLE_NEW_REFERRAL_URL_FORMAT === 'true') {
    return createReferralLinkForNewFormat(supplierName, utm_source);
  }

  return createReferralLinkForOldFormat(supplierName, utm_source);
};
